import Entity from '../entity';
export default class FlightSegment extends Entity<string> {
  name: string;
}
